
export function initDataAttributesActionClick() {

    document.addEventListener('click', e => {
        
        const actionTarget = e.target.closest('[data-action]');
        
        if (actionTarget) {
            
            console.log(actionTarget.dataset.action);
            
            switch (actionTarget.dataset.action) {
                
                // - Lift
                case 'up-page':

                    window.scrollTo(0, 0);
    
                    break;

            }

        }


    });

};